module.exports = function isBoolean(x) {
  return x === true || x === false;
};


//////////////////
// WEBPACK FOOTER
// /produit/nodejs/bin/node-v14.19.0-linux-x64/lib/~/tcomb/lib/isBoolean.js
// module id = 150
// module chunks = 0